import { Form, Input, message } from "antd";
import React, { useEffect, useRef } from "react";
import rpmService from "../../../../../Services/rpmService";
import { convertUTCDate } from "../../../../../utils/convertionFunc";
import { useDispatch, useSelector } from "react-redux";
import { handleSetPatientRegistrationPayload } from "../../../../../Redux/actions/patientActions";

function AddInsuranceDetails({
  children,
  handleCancel,
  currPageView,
  handleNext,
  handlePrevious,
  currLocalMappedChronics,
}) {
  const formRef = useRef();
  const dispatch = useDispatch();
  const { registrationPayload, selectedEditPatient } = useSelector(
    (state) => state.patients
  );
  const loggedUserObj = localStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;


  useEffect(() => {
    formRef.current.setFieldsValue({
      height: selectedEditPatient?.height,
      weight: selectedEditPatient?.weight,
      insuranceId1: selectedEditPatient?.insuranceId1,
      insuranceId2: selectedEditPatient?.insuranceId2,
      insuranceName1: selectedEditPatient?.insuranceName1,
      insuranceName2: selectedEditPatient?.insuranceName2,
      patientGroupNumber: selectedEditPatient?.patientGroupNumber,
    });
  }, [selectedEditPatient]);

  const handleInsDetailsSave = async () => {
    const {
      height,
      weight,
      insuranceId1,
      insuranceId2,
      insuranceName1,
      insuranceName2,
      patientGroupNumber,
    } = formRef.current.getFieldValue();

    if (
      !height ||
      !weight ||
      !insuranceId1 ||
      !insuranceName1 ||
      !patientGroupNumber
    ) {
      handleNext();
      return;
    }

    const payload = {
      ...registrationPayload,
      patientChronicConditionsList: currLocalMappedChronics,
      insuranceId1,
      insuranceId2,
      insuranceName1,
      insuranceName2,
      patientGroupNumber,
      height: Number(height),
      weight: Number(weight),
    };

    dispatch(handleSetPatientRegistrationPayload(payload));
    handleNext();
  };

  return (
    <>
      <Form
        ref={formRef}
        layout="vertical"
        className="w-full grid md:grid-cols-4 gap-4 grid-cols-1 md:justify-center  md:items-center"
      >
        <div>
          <Form.Item
            label={
              <span>
                Height <span style={{ color: "#FF000F" }}>*</span>
              </span>
            }
            name="height"
          >
            <Input placeholder="Enter" />
          </Form.Item>
        </div>
        <div>
          <Form.Item
            label={
              <span>
                Weight <span style={{ color: "#FF000F" }}>*</span>
              </span>
            }
            name="weight"
          >
            <Input placeholder="Enter" />
          </Form.Item>
        </div>
        <div>
          <Form.Item
            label={
              <span>
                Insurance Name 1 <span style={{ color: "#FF000F" }}>*</span>
              </span>
            }
            name="insuranceName1"
          >
            <Input placeholder="Enter" />
          </Form.Item>
        </div>
        <div>
          <Form.Item
            label={
              <span>
                ID No.1 <span style={{ color: "#FF000F" }}>*</span>
              </span>
            }
            name="insuranceId1"
          >
            <Input placeholder="Enter" />
          </Form.Item>
        </div>
        <div>
          <Form.Item
            label={
              <span>
                Group No <span style={{ color: "#FF000F" }}>*</span>
              </span>
            }
            name="patientGroupNumber"
          >
            <Input placeholder="Enter" />
          </Form.Item>
        </div>
        <div>
          <Form.Item
            label={<span>Insurance Name 2</span>}
            name="insuranceName2"
          >
            <Input placeholder="Enter" />
          </Form.Item>
        </div>
        <div>
          <Form.Item label={<span>ID No.2</span>} name="insuranceId2">
            <Input placeholder="Enter" />
          </Form.Item>
        </div>
      </Form>

      {/* Consent Forms Section */}
      <div className="col-span-full">{children}</div>

      <div className="flex md:flex-row text-center flex-col md:items-center items-end justify-end gap-3 ">
        <button
          disabled={currPageView === 1}
          className={`${
            currPageView > 1 ? "block" : "hidden"
          } md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50 text-white`}
          onClick={handlePrevious}
        >
          Previous
        </button>
        <button
          className="md:min-w-24 w-[3rem] md:w-24  h-8 p-1 bg-brand-White rounded-lg border bg-white border-brand-primaryColor font-semibold custom-button-shadow"
          onClick={handleCancel}
        >
          Cancel
        </button>
        <button
          className="md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50 text-white"
          onClick={handleInsDetailsSave}
        >
          Next
        </button>
      </div>
    </>
  );
}

export default AddInsuranceDetails;
